import { Component, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalDirective} from 'ngx-bootstrap';
import {FamilyService} from '../services/family.service';
import {AngularFireDatabase} from 'angularfire2/database';
import {User} from 'firebase';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild(ModalDirective) modal: ModalDirective;
  @ViewChild(ModalDirective) modalLock: ModalDirective;
  @ViewChild(ModalDirective) modalUnlock: ModalDirective;
  modalRef: BsModalRef;
  modalLockRef: BsModalRef;
  public loading = false;
  public usuario: string;
  public action: string;
  public appReady: boolean;
  public showStatusButton = false;
  public modalConf = {title:"", question: "", type:""};
  public accessBackoffice = true;
  constructor(public db: AngularFireDatabase,
              private route: ActivatedRoute,
              private router: Router,
              private auth: AuthService,
              private modalService: BsModalService,
              private familyService: FamilyService) {}

  ngOnInit() {
    this.auth.getUsuario().subscribe(resp => {
      if (resp && resp.email) {
        this.usuario = resp.email.split('@')[0];
      }
    });

    this.familyService.getStatusApp().subscribe(resp => {
      if (resp!==null && resp!== undefined) {
        this.appReady = resp
        this.showStatusButton = true;
      }
    });
  }

  logout() {
    this.auth.logout();
  }

  resetBase(){
    this.modalConf.title = "Alerta"
    this.modalConf.question = "¿Está seguro que desea resetear los paneles de notificacion?";
    this.modalConf.type="reset"
    this.modal.show();
  }

  lockApp(){
    this.modalConf.title = "Llamado de padres"
    this.modalConf.question = "¿Desea bloquear el llamado de padres?";
    this.modalConf.type="bloquear";
    this.action = 'bloquear'
    this.modal.show();
  }

  unlockApp(){
    this.modalConf.title = "Llamado de padres"
    this.modalConf.question = "¿Desea habilitar el llamado de padres?";
    this.modalConf.type="habilitar";
    this.action = 'habilitar'
    this.modal.show();
  }

  enableStatusApp(){
    this.familyService.habilitarPadres();
    this.action = 'bloquear';
    this.appReady = true;
    this.modal.hide();

  }

  disableStatusApp(){
    this.familyService.bloquearPadres()
    this.action = 'habilitar';
    this.appReady = false;
    this.modal.hide();
  }

  confirm(type){
    switch (type) {
      case "reset":
        this.confirmResetBase();
        break;
      case "habilitar":
        this.enableStatusApp();
        break;
      case "bloquear":
        this.disableStatusApp();
        break;
    }
      
  }

  async confirmResetBase(){
    this.loading = true;
    await this.db.list('/retirados').remove();
    await this.db.list('/grado1').remove();
    await this.db.list('/grado2').remove();
    await this.db.list('/grado3').remove();
    await this.db.list('/grado4').remove();
    await this.db.list('/grado5').remove();
    await this.db.list('/grado6').remove();
    await this.db.list('/grado7').remove();
    await this.db.list('/gradoK5').remove();
    await this.db.list('/gradoK4-TT').remove();
    await this.db.list('/gradoK4-TM').remove();
    await this.db.list('/gradoK3-TT').remove();
    await this.db.list('/gradoK3-TM').remove();
    await this.db.list('/gradoK2-TT').remove();
    await this.db.list('/gradoK2-TM').remove();
    await this.db.list('/todos').remove();
    console.log('fin deletes')
    this.db.list('/').snapshotChanges().pipe(take(1)).subscribe(r => {
      r.forEach(f => {
        if(!isNaN(parseInt(f.key))){
          this.db.list('/'+f.key).snapshotChanges().pipe(take(1)).subscribe(r2 => {
            r2.forEach(async (f2) => {
              await this.db.object('/' + f.key + '/' + f2.key + '/retirado').set(0);
            })
          })
        }
      })
    });

      this.loading = false;
      this.modal.hide();
  }

  seeAll(){

  }


}
